import { render, staticRenderFns } from "./SiteNewForm.vue?vue&type=template&id=68e8b9bb"
import script from "./SiteNewForm.vue?vue&type=script&lang=js"
export * from "./SiteNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports